var map = {
	"./Untitled-1.jpg": 6789,
	"./Untitled-10.jpg": 8812,
	"./Untitled-11.jpg": 30078,
	"./Untitled-12.jpg": 63742,
	"./Untitled-13.jpg": 93917,
	"./Untitled-14.jpg": 92392,
	"./Untitled-15.jpg": 38071,
	"./Untitled-2.jpg": 22019,
	"./Untitled-3.jpg": 83653,
	"./Untitled-4.jpg": 47443,
	"./Untitled-5.jpg": 83537,
	"./Untitled-6.jpg": 85260,
	"./Untitled-7.jpg": 36176,
	"./Untitled-8.jpg": 98751,
	"./Untitled-9.jpg": 93392
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80940;